import React from 'react';
import { Field } from 'formik';

import { InputUI, AutoCompleteSelectUI, FormErrorUI, FormLabelUI } from '../Interface';

export const OperationFormFields = ({ values, validateField, setFieldValue, errors, productionList, user, params }) => {
  return (
    <div className="grid grid-cols-4 gap-x-4 gap-y-2">
      <div className="col-span-4 md:col-span-2">
        <Field
          type="autocomplete"
          name="userId"
          component={AutoCompleteSelectUI}
          fullWidth
          label={<FormLabelUI text="Dolgozó" />}
          variant="standard"
          helperText={<FormErrorUI message={errors.userId} />}
          onChange={(_e, newVal) => {
            setFieldValue('userId', newVal?.value ?? null).then(() => {
              validateField('userId');
            });
          }}
          InputLabelProps={{ shrink: values.userId !== '' }}
          selectedValue={values.userId}
          selectedLabelValue={user?.nickName}
          table={'WebUser'}
          listType={{ id: 'userId', name: 'nickName' }}
          conditions={[`WebUser.archive = 'N'`]}
        />
      </div>
      <div
        className={`${params.QUANTITY_UNIT_HOUR_CODE === productionList.operationQuantityUnit ? '' : 'hidden'} col-span-4 md:col-span-2`}
      >
        <Field
          type="text"
          name="timeSpent"
          as={InputUI}
          fullWidth
          label={<FormLabelUI text="Ráfordított idő (óra)" />}
          helperText={<FormErrorUI message={errors.timeSpent} />}
          InputLabelProps={{ shrink: values.timeSpent !== '' }}
          variant="standard"
        />
      </div>
      <div
        className={`${params.QUANTITY_UNIT_HOUR_CODE === productionList.operationQuantityUnit ? 'hidden' : ''} col-span-4 md:col-span-2`}
      >
        <Field
          type="text"
          name="timeSpentInMin"
          as={InputUI}
          fullWidth
          label={<FormLabelUI text="Ráfordított idő (perc)" />}
          InputLabelProps={{ shrink: values.timeSpentInMin && values.timeSpentInMin !== '' }}
          variant="standard"
        />
      </div>
      <div className="col-span-4 md:col-span-2">
        <Field
          type="number"
          name="quantity"
          as={InputUI}
          fullWidth
          label={
            <FormLabelUI
              text={`Mennyiség ${productionList && productionList.quantityUnit ? `(${productionList.quantityUnit})` : ''}`}
            />
          }
          helperText={<FormErrorUI message={errors.quantity} />}
          InputLabelProps={{ shrink: values.quantity !== '' }}
          variant="standard"
        />
      </div>
      <div className="col-span-4 md:col-span-2">
        <Field
          type="number"
          name="scrapQuantity"
          as={InputUI}
          fullWidth
          label={
            <FormLabelUI
              text={`Selejt Mennyiség ${productionList && productionList.quantityUnit ? `(${productionList.quantityUnit})` : ''}`}
            />
          }
          helperText={<FormErrorUI message={errors.scrapQuantity} />}
          InputLabelProps={{ shrink: values.scrapQuantity !== '' }}
          variant="standard"
        />
      </div>
    </div>
  );
};
